


export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Delivery Type",
      inputName: "order_type",
      options: [
        {
          name: "Local delivery",
          code: "LOCAL DELIVERY",
        },
        {
          name: "Intercity delivery",
          code: "INTERCITY DELIVERY",
        },
      ],
    },
   
  ]
  
  export const canlenderFilter={
    filterType:"Order Date",
    inputName:"order_date",  
    maxDate :new Date()
  }
  
  
  
  
   
  


export default {  
    filters:filters,
    SearchBy:searchBy  ,
    // WeekRange:WeekRange,
    // MonthRange:MonthRange,
    canlenderFilter:canlenderFilter,    
  }